/* ============================================================================
 * ProblemStatement, direct structural port of growthjockey--website/app/
 * components/sections/intellsysMetricSection.tsx.
 *
 * GJ stat-section pattern:
 *  - Outer: grid grid-cols-1 grid-flow-row gap-sm md:gap-lg
 *  - Header: heading2-25 + text-body description (left-aligned)
 *  - Stat row: 3 cells, each centered on md+, left-aligned on mobile
 *    - Big gradient number (text-big-number + text-gradient-blue)
 *    - text-main-title (the stat label)
 *    - text-body-text-b max-w-80 (the supporting prose)
 *
 * No icons. No tile chrome. No scatter visual. Pure typography hierarchy ,
 * this is how GJ renders every problem/metric/stat section across the site.
 *
 * Content inspired by ClickUp's homepage problem section, adapted to
 * Intellsys-OS's actual problem space: tool sprawl, data silos, manual
 * reconciliation.
 * ============================================================================ */

const problems = [
    {value: "30+", title: "Tool Sprawl", text: "disconnected SaaS tools in every enterprise."},
    {value: "73%", title: "Data Silos", text: "of company data sits unused, siloed across platforms."},
    {value: "12 hrs", title: "Manual Stitching", text: "lost weekly reconciling reports across tools."},
];

export function ProblemStatement() {
    return (
        <section
            aria-labelledby="problem-title"
            className="gj-px-screen-edge-constrained gj-py-section-divider grid grid-cols-1 grid-flow-row gap-sm md:gap-lg"
        >
            <h2
                id="problem-title"
                className="text-heading2-25 text-left lg:text-center"
            >
                <span className="text-gradient-blue whitespace-nowrap">Tool Sprawl.</span>{" "}
                <span className="whitespace-nowrap text-text-primary">Data Loss.</span>
            </h2>

            <div className="relative">
                <img
                    src="https://kanyini-cdn.b-cdn.net/images/Intellsys/context-sprawl-placeholder.png"
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    className="w-full h-auto"
                />
                <div className="pointer-events-none absolute inset-y-0 left-0 w-[15%] bg-gradient-to-r from-surface-primary-background to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-[15%] bg-gradient-to-l from-surface-primary-background to-transparent" />
            </div>

            <div className="grid grid-cols-3 grid-rows-1 gap-2 md:gap-md">
                {problems.map((card) => (
                    <div
                        key={card.title}
                        className="grid grid-cols-1 grid-flow-row gap-2 md:gap-md text-center justify-items-center"
                    >
                        <span className="text-big-number text-gradient-blue">{card.value}</span>
                        <div className="text-main-title">{card.title}</div>
                        <div className="text-body-text-b max-w-80">{card.text}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}
